module.exports = __webpack_public_path__ + "static/media/person-booth.8796e652.svg";